import React from 'react';
import NoDataPlaceholderMessage from 'Components/UI/Table/NoDataPlaceholderMessage';

const NoInsights = () => {
  return (
    <NoDataPlaceholderMessage message="No Insights Available" test="no-insights-available" />
  );
};

export default NoInsights;
